<template>
    <modal-content @close="$emit('close')">
        <project-title-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ProjectTitleForm from '@/modules/ProjectModule/components/Project/Form/ProjectTitleForm';
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';

export default {
    name:       'CreateProjectDialog',
    components: {ModalContent, ProjectTitleForm},
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/createProject', data)
                .then(({id}) => {
                    this.$refs.form.reset();
                    this.$emit('close');
                    this.$router.push({name: 'project-unit-default', params: {projectId: id}});
                });
        }
    }
}
</script>
